// extracted by mini-css-extract-plugin
export default {"productFeatured":"U--z","carousel":"V--z","slides":"W--z","slide":"X--z","slideFeatured":"Y--z","zoomMode":"Z--z","fadeIn":"_--z","imageSizing":"a_-z"};